import { HFlow, Text } from 'bold-ui'
import { CustomSelectFieldProps, SelectField } from 'components/form/core'
import { CboSelectFieldDocument } from 'graphql/hooks.generated'
import { Cbo, CboSelectFieldQuery, CboSelectFieldQueryVariables } from 'graphql/types.generated'

import { DEFAULT_SELECT_PAGE_PARAM, useAsyncQuerySelect } from '../useAsyncQuerySelect'

export type CboSelectModel = Cbo

export type CboSelectFieldProps = CustomSelectFieldProps<CboSelectModel> & {
  mostrarIndisponivelLotacao?: boolean
  codigoCboSupervisor?: string
  apenasEquipeCuidadoCompartilhado?: boolean
  equipeVinculadaId?: ID
  nivelSuperior?: boolean
  excludeProfissionaisIds?: ID[]
  profissionalPrescritor?: boolean
}

export function CboSelectField(props: CboSelectFieldProps) {
  const {
    codigoCboSupervisor,
    mostrarIndisponivelLotacao,
    apenasEquipeCuidadoCompartilhado,
    equipeVinculadaId,
    nivelSuperior,
    excludeProfissionaisIds,
    profissionalPrescritor,
    ...rest
  } = props

  const { selectProps } = useAsyncQuerySelect<CboSelectModel, CboSelectFieldQuery, CboSelectFieldQueryVariables>({
    query: CboSelectFieldDocument,
    extractItems: (data) => data?.cbos?.content.map((item) => item.cbo),
    variables: (inputQuery) => ({
      input: {
        query: inputQuery,
        mostrarIndisponivelLotacao,
        apenasEquipeCuidadoCompartilhado,
        equipeVinculadaId,
        nivelSuperior,
        cboSupervisor: codigoCboSupervisor,
        excludeProfissionaisIds,
        profissionalPrescritor,
        pageParams: pageParams,
      },
    }),
  })

  const itemToString = (op: CboSelectModel) => op?.nome
  const renderItem = (item: CboSelectModel) => (
    <>
      <Text fontWeight='bold'>{item.nome}</Text>
      <HFlow hSpacing={0.5}>
        <Text fontWeight='bold'>Código:</Text>
        {item.cbo2002}
      </HFlow>
    </>
  )

  return <SelectField<CboSelectModel> itemToString={itemToString} renderItem={renderItem} {...selectProps} {...rest} />
}

const pageParams = {
  ...DEFAULT_SELECT_PAGE_PARAM,
  sort: ['nome'],
}
